import { render, staticRenderFns } from "./ReceiptsSmsVoucher.vue?vue&type=template&id=6901376c&scoped=true&"
import script from "./ReceiptsSmsVoucher.vue?vue&type=script&lang=js&"
export * from "./ReceiptsSmsVoucher.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsSmsVoucher.vue?vue&type=style&index=0&id=6901376c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6901376c",
  null
  
)

export default component.exports